( function( $ ) {
	let initBlock = function() {
		let $productIntro = $( '.hmt-product-intro-container' );

		$( '.js-section-product-gallery' ).each( function() {
			let $this = $( this );
			let $sliderProductGallery = $this;
			let $sliderProductGalleryThumbs = $this.siblings( '.js-section-product-gallery-thumbs' );

			const loadSliders = () => {
				if ( $sliderProductGalleryThumbs[0].swiper ) {
					$sliderProductGalleryThumbs[0].swiper.destroy( true, true );
				}

				if ( $sliderProductGallery[0].swiper ) {
					$sliderProductGallery[0].swiper.destroy( true, true );
				}

				let sliderProductGalleryThumbs = new Swiper( $sliderProductGalleryThumbs[0], {
					slidesPerView: 'auto',
					speed: 1000,
					spaceBetween: 10,
					rewind: true,
					centeredSlides: false,
					centerInsufficientSlides: false,
					slideToClickedSlide: true,
					on: {
						init: function( sliderProductGalleryThumbs ) {
							if ( window.matchMedia( '(min-width: 768px)' ).matches ) {
								sliderProductGalleryThumbs.changeDirection( 'vertical' );
							} else {
								sliderProductGalleryThumbs.changeDirection( 'horizontal' );
							}
						},
						resize: function( sliderProductGalleryThumbs ) {
							if ( window.matchMedia( '(min-width: 768px' ).matches ) {
								sliderProductGalleryThumbs.changeDirection( 'vertical' );
							} else {
								sliderProductGalleryThumbs.changeDirection( 'horizontal' );
							}
						},
						click: function( swiper, event ) {
							let $swiperSlideClicked = $( event.target ).closest( '.js-section-product-gallery-thumbs .swiper-slide' );
							if ( $swiperSlideClicked.length ) {
								let activeIndex = $swiperSlideClicked.attr( 'data-slide-index' );
								sliderProductGalleryThumbs.slideTo( activeIndex, 1000 );
							}
						}
					},
				} );

				let sliderProductGallery = new Swiper( $sliderProductGallery[0], {
					slidesPerView: 1,
					speed: 1000,
					spaceBetween: 10,
					effect: 'fade',
					fadeEffect: {
						crossFade: true,
					},
					rewind: true,
					thumbs: {
						swiper: sliderProductGalleryThumbs,
					},
					navigation: {
						nextEl: $this.closest( '.section-product-gallery__media-wrapper' ).find( '.section-product-gallery__slider-nav .swiper-button-next' )[0],
						prevEl: $this.closest( '.section-product-gallery__media-wrapper' ).find( '.section-product-gallery__slider-nav .swiper-button-prev' )[0],
					},
					pagination: {
						el: $this.closest( '.section-product-gallery__media-wrapper' ).find( '.section-product-gallery__slider-nav .section-product-gallery__slider-pagination' )[0],
						type: 'fraction',
					},
					on: {
						activeIndexChange: function( swiper ) {
							let activeIndex = swiper.activeIndex;
							sliderProductGalleryThumbs.slideTo( activeIndex, 1000 );
						}
					},
				} );

				if ( $sliderProductGallery.closest( '.section-woo-product-gallery' ).length && $( '.product-type-variable' ).length ) {
					let $mainImage = $sliderProductGallery.find( '.media-fit' ).first();
					let $mainThumbImage = $sliderProductGalleryThumbs.find( '.media-fit' ).first();

					if ( !$mainImage && !$mainThumbImage ) {
						return;
					}

					let defaultMainImageHTML = $mainImage.html();
					let defaultMainThumbImageHTML = $mainThumbImage.html();

					$( '.variations_form' ).on( 'woocommerce_variation_select_change', function() {
						if ( $mainImage.html() !== defaultMainImageHTML ) {
							$mainImage.html( defaultMainImageHTML );
							$mainThumbImage.html( defaultMainThumbImageHTML );
						}
					} );

					$( '.single_variation_wrap' ).on( 'show_variation', function( event, variation ) {
						if ( variation.image.src ) {
							$mainImage.html( createProductImg( variation.image, false, false ) );
							$mainThumbImage.html( createProductImg( variation.image, false, $sliderProductGalleryThumbs.find( '.background-img img' ).last().attr( 'class' ) ) );
							sliderProductGallery.slideTo( 0, 1000 );
						}
					} );
				}
			};

			window.app.loadVendor( 'Swiper', loadSliders );
		} );

		if ( $productIntro.find( '.section-woo-product-gallery' ).length && !$productIntro.find( '.js-section-product-gallery' ).length && $( '.product-type-variable' ).length ) {
			let $mainImage = $productIntro.find( '.media-fit' ).first();

			if ( !$mainImage ) {
				return;
			}
			let defaultMainImageHTML = $mainImage.html();

			$( '.variations_form' ).on( 'woocommerce_variation_select_change', function() {
				if ( $mainImage.html() !== defaultMainImageHTML ) {
					$mainImage.html( defaultMainImageHTML );
				}
			} );

			$( '.single_variation_wrap' ).on( 'show_variation', function( event, variation ) {
				if ( !variation.image.src ) {
					$mainImage.html( defaultMainImageHTML );
				}

				if ( variation.image.src ) {
					$mainImage.html( createProductImg( variation.image, false, false ) );
				}
			} );
		}

		let createProductImg = ( imgObject, srcOnly, classes ) => {
			if ( !imgObject.src ) {
				return '';
			}

			let newImage = new Image();
			newImage.src = imgObject.src;

			if ( classes ) {
				newImage.className = classes;
			}

			if ( srcOnly ) {
				return newImage;
			}

			if ( imgObject.srcset && imgObject.sizes ) {
				newImage.srcset = imgObject.srcset;
				newImage.sizes = imgObject.sizes;
			}

			return newImage;
		};
	};

	window.app.loadBlock( initBlock, 'section-woo-product-gallery', '.section-woo-product-gallery' );
} )( jQuery );
